import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Add CSP meta tag before React renders
const cspMeta = document.createElement('meta');
cspMeta.httpEquiv = "Content-Security-Policy";
cspMeta.content = `
  default-src 'self';
  script-src 'self' 'unsafe-eval';
  style-src 'self' 'unsafe-inline';
  img-src 'self' data:;
  connect-src 'self' https://company-application-platform-backend.onrender.com http://localhost:8080;
  font-src 'self' data:;
  frame-src 'self';
  media-src 'self';
  object-src 'none';
`;
document.head.appendChild(cspMeta);

// Create root and render
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// Report web vitals
reportWebVitals();